import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackingService } from '../lib/tracking/tracking-service';

/**
 * Component that tracks page views on route changes, from the real URL
 * (trackPageView default).
 */
export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackingService.trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
